module.exports = __webpack_public_path__ + "img/1_uk.d224fb9f.svg";